import { EGelirGiderDurumID } from "@shared/models";

export interface IGelirGider{
    gelirID: number;
    durumID: EGelirGiderDurumID;
    tarih: Date;
    masrafKalemKodu: string;
    masrafKalemAdi: string;
    bakiye: number;
}

export class GelirGiderFilter {
    tarih: string;
    durumID: EGelirGiderDurumID;
}